import React from "react";
import AnonymousPage from "@/models/base/AnonymousPage";
import {
    Form,
    PageContainer,
    PageHeader,
} from "@reapptor-apps/reapptor-react-components";
import ReactMarkdown from "react-markdown";
import styles from "./Feedback.module.scss";
import Localizer from "@/localization/Localizer";
import {DynamicPageData, DynamicPageResponseSingleType} from "@/models/cms/DynamicPageResponse";


export interface IFeedbackParams {}
interface IPrivacyPolicyState {
    feedbackContent: DynamicPageData | null;
}

export default class Feedback extends AnonymousPage {

    state: IPrivacyPolicyState = {
        feedbackContent: null
    };


    public formRef: React.RefObject<Form> = React.createRef();

    async initializeAsync(): Promise<void> {
        await super.initializeAsync();
        const response: DynamicPageResponseSingleType = await this.getAsync(
            "/api/Application/GetDynamicPageContent?contentType=feedback&populate=*"
        );
        await this.setState({feedbackContent: response.data});
        window.scrollTo(0, 0);
    }


    public render(): React.ReactNode {

        return (
            <PageContainer fullWidth className={styles.pageContainer}>
                <PageHeader className={styles.pageHeader} title={Localizer.companyPageFeedback}/>
                <div className={styles.pageContent}>
                    <div className={styles.fluidContent}>
                        {this.state.feedbackContent && (
                            <>
                                {this.state.feedbackContent.attributes?.title && 
                                    <h3>{this.state.feedbackContent.attributes?.title}</h3>
                                }
                                {this.state.feedbackContent.attributes?.content &&
                                    <ReactMarkdown>{this.state.feedbackContent.attributes.content}</ReactMarkdown>
                                }
                            </>
                        )}
                    </div>
                </div>
            </PageContainer>
        );
    }
}